import "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

/**
 * Loading indicator component that displays a lottie animation
 * @returns A loading indicator component
 */
export const InsightLoadingIndicator = () => (
  <div className="h-auto w-[70px] inline-flex">
    <DotLottieReact src="/loader.lottie" loop autoplay />
  </div>
);
